import React, { Component } from 'react';
import _ from 'lodash';
import ReactDataGrid from 'react-data-grid';
import { Toolbar, Data } from 'react-data-grid-addons';
import { Row, Col, Panel, Button, ButtonToolbar, Input } from 'react-bootstrap';
import Dropzone from 'react-dropzone';
import PropTypes from 'prop-types';
import { Translate } from 'react-redux-i18n';

import ContentWrapper from '../../components/Layout/ContentWrapper';
import GenericSelection from '../Common/GenericSelection';
import Spinner from '../../components/Widgets/spinner';
import SpinnerButton from '../Common/SpinnerButton';
import { ROOT_URL, ROOT_API_URL, companyCodeTitle } from '../../actions/root_url';

const isAFM = ROOT_API_URL === 'https://afm-scm.truckxi.com/api/' || ROOT_URL === 'https://afm-scm.truckxi.com/api/';

const {
  Draggable: { Container: DraggableContainer, RowActionsCell, DropTargetRowContainer },
  Data: { Selectors },
} = require('react-data-grid-addons');

const RowRenderer = DropTargetRowContainer(ReactDataGrid.Row);

class BillboardImagesTable extends Component {
  constructor(props) {
    super(props);

    this.state = {
      rows: [],
      selectedRows: null,
      sortColumn: null,
      sortDirection: null,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.rows && nextProps.rows !== this.props.rows) {
      nextProps.rows.map((row, index) => {
        row.Index = index;
      });
      this.setState({ rows: nextProps.rows });
    }
  }

  onDrop = (row, files) => {
    if (!files) {
      return;
    }
    const reader = new FileReader();
    reader.onload = () => {
      const index = row.props.rowIdx;
      const newRows = _.cloneDeep(this.state.rows);
      newRows[index].Image = reader.result;
      this.setState({ rows: newRows });
    };
    // get the first file and convert to blob object (Blob.slice([start [, end [, contentType]]))
    const blob = files[0].slice(0, files[0].size, files[0].type);
    reader.readAsDataURL(blob);
  }

  saveImages = (e) => {
    e.preventDefault();
    const rows = this.state.rows.filter((row) => {
      const match = (row.Image !== undefined);
      return match;
    });
    this.setState({ rows }, () => {
      this.props.saveBillboardImages(this.state.rows)
        .then(() => {
          this.props.reload();
        });
    });
  }

  addNewImageRow = (e) => {
    e.preventDefault();
    const rows = Data.Selectors.getRows(this.state);
    if (rows.length === 20) {
      alert('Max of 20 images!');
      return;
    }
    const index = rows.length;
    const newRow = {
      IsEnabled: true, Index: index,
    };
    rows.push(newRow);
    this.setState({ rows });
  }

  deleteRow = () => {
    const { selectedRows } = this.state;
    if (!selectedRows || selectedRows.length === 0) {
      alert('Select a row to delete!');
      return;
    }
    const { id } = selectedRows[0];
    if (id) {
      this.props.delete(id)
        .then(() => {
          this.props.reload();
        });
    } else {
      const rows = _.cloneDeep(this.state.rows);
      const index = _.findIndex(rows, { Index: selectedRows[0].Index });
      rows.splice(index, 1);
      rows.map((row, rowIndex) => {
        row.Index = rowIndex;
      });
      this.setState({ rows, selectedRows: [] });
    }
  }

  renderImage = (index) => {
    const imageFile = (this.state.rows[index].Image || '/img/dummy.png');
    return (
      <div className="img-view">
        <img
          src={imageFile}
          alt="Upload"
          className="default-image"
        />
      </div>
    );
  }

  renderTable() {
    if (this.props.rowsIsLoading) {
      return <Spinner />;
    }
    const getRows = () => Data.Selectors.getRows(this.state);

    const getSize = () => getRows().length;

    const rowGetter = (rowIdx) => {
      const rows = getRows();
      return rows[rowIdx];
    };

    const handleRowUpdated = (e) => {
      // merge updated row with current row and rerender by setting state
      this.setState({ sortColumn: null, sortDirection: null });
      const rows = getRows();
      Object.assign(rows[e.rowIdx], e.updated);
      this.setState({ rows });
    };

    const handleIsEnabledClick = (isEnabled) => {
      const rows = getRows();
      if (isEnabled.value === false) {
        let enabledCount = 0;
        rows.map((row) => {
          if (row.IsEnabled === true) {
            enabledCount += 1;
          }
        });
        if (enabledCount === 6) {
          alert('Only 6 images can be enabled at a time');
          return;
        }
      }
      const index = _.findIndex(rows, { Index: isEnabled.dependentValues.Index });
      rows[index].IsEnabled = !(rows[index].IsEnabled);
      this.setState({ rows });
    };

    const onRowsSelected = (rows) => {
      const newRows = getRows();
      newRows.map((r) => {
        r.isSelected = false;
      });
      rows.map((r) => {
        newRows[r.rowIdx].isSelected = true;
      });
      this.setState({
        rows: newRows, selectedRows: [rows[0].row],
      });
    };

    const onRowsDeselected = (rows) => {
      const newRows = getRows();
      rows.map((r) => {
        newRows[r.rowIdx].isSelected = false;
      });
      this.setState({ rows: newRows, selectedRows: [] });
    };

    const isDraggedRowSelected = (selectedRows, rowDragSource) => {
      if (selectedRows && selectedRows.length > 0) {
        const key = this.props.rowKey;
        return selectedRows.filter(r => r[key] === rowDragSource.data[key]).length > 0;
      }
      return false;
    };

    const reorderRows = (e) => {
      const selectedRows = Selectors.getSelectedRowsByKey({ rowKey: this.props.rowKey, selectedKeys: [], rows: this.state.rows });
      const draggedRows = isDraggedRowSelected(selectedRows, e.rowSource) ? selectedRows : [e.rowSource.data];
      const undraggedRows = this.state.rows.filter(r => draggedRows.indexOf(r) === -1);
      const args = [e.rowTarget.idx, 0].concat(draggedRows);
      Array.prototype.splice.apply(undraggedRows, args);
      undraggedRows.map((row, index) => {
        row.Index = index;
      });
      this.setState({ rows: undraggedRows });
    };

    const IsEnabledFormatter = React.createClass({
      render() {
        return (
          <div style={{display: 'flex', justifyContent: 'center'}}>
          <input
            id="billboard-image-enable"
            type="checkbox"
            value="true"
            checked={this.props.value === true || this.props.value === 'true'}
            onClick={() => { handleIsEnabledClick(this.props); }}
          />
          </div>
        );
      },
    });

    const ThumbnailFormatter = React.createClass({
      render() {
        return (
          <div id="billboard-image-container">
            <Dropzone
              onDrop={this.props.onDrop.bind(this.props.dependentValues.Index, this)}
              className="billboard-image-dropzone"
              accept="image/*"
            >
              <div>
                { this.props.renderImage(this.props.dependentValues.Index) }
              </div>
              <Button
                id="dropzone-button"
                bsStyle="primary"
                type="button"
              >
                <em className="fa fa-plus" />
              </Button>
            </Dropzone>
          </div>
        );
      },
    });

    const InputFormatter = React.createClass({
      onChange(url) {
        const newRows = getRows();
        const index = this.props.dependentValues.Index;
        newRows[index].URL = url;
        this.setState({ rows: newRows });
      },
      render() {
        return (
          <div>
            <Input
              type="text"
              name="url"
              onChange={event => this.onChange(event.target.value)}
              value={this.props.dependentValues.URL}
            />
          </div>
        );
      },
    });

    const LinkTypeFormatter = React.createClass({
      handleTypeSelect(type) {
        const newRows = getRows();
        const index = this.props.dependentValues.Index;
        newRows[index].MIMEType = type;
        this.setState({ rows: newRows });
      },
      render() {
        const linkOptions = [
          { value: 'URL', label: <Translate value="url" /> },
          { value: 'Category2', label: <Translate value="category_2" /> },
          { value: 'Group', label: <Translate value="group" /> },
          { value: 'Category', label: <Translate value="category" /> },
        ];
        return (
          <div className="billboard-display-options2">
            <GenericSelection
              options={linkOptions}
              value={this.props.dependentValues.MIMEType}
              setSelected={(e) => {
                this.handleTypeSelect(e.value);
              }}
            />
          </div>
        );
      },
    });

    const LangFormatter = React.createClass({
      handleLangSelect(lang) {
        const newRows = getRows();
        const index = this.props.dependentValues.Index;
        newRows[index].Language = lang;
        this.setState({ rows: newRows });
      },
      render() {
        const langOptions = [
          { value: 'en', label: <Translate value="en" /> },
          { value: 'ch', label: <Translate value="ch" /> },
        ];
        return (
          <div className="billboard-display-options">
            <GenericSelection
              options={langOptions}
              value={this.props.dependentValues.Language}
              setSelected={(e) => {
                this.handleLangSelect(e.value);
              }}
            />
          </div>
        );
      },
    });

    const CustomerFormatter = React.createClass({
      handleCustomerSelect(customer) {
        const newRows = getRows();
        const index = this.props.dependentValues.Index;
        newRows[index].CustomerType = customer;
        this.setState({ rows: newRows });
      },
      render() {
        const customerOptions = [
          { value: 'all', label: <Translate value="all" /> },
          { value: 'b2b', label: 'B2B' },
          { value: 'b2c', label: 'B2C' },
        ];
        return (
          <div className="billboard-display-options">
            <GenericSelection
              options={customerOptions}
              value={this.props.dependentValues.CustomerType}
              setSelected={(e) => {
                this.handleCustomerSelect(e.value);
              }}
            />
          </div>
        );
      },
    });

    const columns = [
      {
        key: 'Thumbnail',
        name: <Translate value="thumbnail" />,
        resizeable: true,
        width: 400,
        sortable: false,
        editable: false,
        filterable: false,
        formatter: <ThumbnailFormatter renderImage={this.renderImage} onDrop={this.onDrop} />,
        getRowMetaData: row => row,
      },
      {
        key: 'IsEnabled',
        name: <Translate value="enabled" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
        formatter: IsEnabledFormatter,
        getRowMetaData: row => row,
      },
      {
        key: 'URL',
        name: <Translate value="link" />,
        resizable: true,
        width: 320,
        filterable: true,
        formatter: InputFormatter,
        getRowMetaData: row => row,
      },
      {
        key: 'Language',
        name: <Translate value="language" />,
        resizable: true,
        width: 95,
        filterable: false,
        formatter: LangFormatter,
        getRowMetaData: row => row,
      },
      {
        key: 'CustomerType',
        name: <Translate value="b2b_b2c" />,
        resizable: true,
        width: 75,
        filterable: false,
        formatter: CustomerFormatter,
        getRowMetaData: row => row,
      },
    ];

    if (isAFM) {
      const indexCol = _.findIndex(columns, { key: "URL" });
      const typeColumn = {
        key: 'MIMEType',
        name: <Translate value="Type" />,
        resizable: true,
        width: 150,
        filterable: true,
        formatter: LinkTypeFormatter,
        getRowMetaData: row => row,
      };
      columns.splice(indexCol, 0, typeColumn);
    }

    return (
      <Row>
        <Col sm={12}>
          <DraggableContainer>
            <ReactDataGrid
              columns={columns}
              enableCellSelect
              minHeight={620}
              rowHeight={200}
              headerRowHeight={25}
              enableRowSelect="single"
              onRowUpdated={handleRowUpdated}
              rowGetter={rowGetter}
              rowsCount={getSize()}
              rowActionsCell={RowActionsCell}
              rowRenderer={<RowRenderer onRowDrop={reorderRows} />}
              toolbar={<Toolbar />}
              rowSelection={{
                showCheckbox: true,
                onRowsSelected,
                onRowsDeselected,
                selectBy: {
                  isSelectedKey: 'isSelected',
                },
              }}
            />
          </DraggableContainer>
        </Col>
      </Row>
    );
  }

  render() {
    const { saving, deleting } = this.props;
    return (
      <Panel id="mobile-billboard-images">
        <ContentWrapper>
          <ButtonToolbar>
            <SpinnerButton
              bsStyle="success"
              disabled={saving}
              onClick={this.saveImages}
              loading={saving}
              icon="fa-save"
              translation={<Translate value="save" />}
            />
            <Button
              bsStyle="primary"
              onClick={this.addNewImageRow}
            >
              <em className="fa fa-plus" /><Translate value="create" />
            </Button>
            <SpinnerButton
              bsStyle="danger"
              disabled={deleting}
              onClick={this.deleteRow}
              loading={deleting}
              icon="fa-trash"
              translation={<Translate value="delete" />}
            />
          </ButtonToolbar>
          {this.renderTable()}
        </ContentWrapper>
      </Panel>
    );
  }
}

BillboardImagesTable.defaultProps = {
  rows: [],
  rowsIsLoading: false,
  rowKey: 'Index',
  value: false,
  saving: false,
  dependentValues: {},
  deleting: false,
  renderImage: () => {},
  onDrop: () => {},
  saveBillboardImages: () => {},
  reload: () => {},
  delete: () => {},
};

BillboardImagesTable.propTypes = {
  rows: PropTypes.array,
  rowsIsLoading: PropTypes.bool,
  rowKey: PropTypes.string,
  dependentValues: PropTypes.shape({
    Index: PropTypes.number,
    URL: PropTypes.string,
    Language: PropTypes.string,
    MIMEType: PropTypes.string,
    CustomerType: PropTypes.string,
  }),
  reload: PropTypes.func,
  saveBillboardImages: PropTypes.func,
  saving: PropTypes.bool,
  renderImage: PropTypes.func,
  onDrop: PropTypes.func,
  value: PropTypes.bool,
  delete: PropTypes.func,
  deleting: PropTypes.bool,
};

export default BillboardImagesTable;



// WEBPACK FOOTER //
// ./master/jsx/components/General/BillboardImagesTable.jsx